import * as React from 'react';

import { Client } from '@rematter/frontend-lib-api-client';
import { Client as SSEClient } from 'graphql-sse';

type Operation = 'query' | 'mutation' | 'subscription';
type Module = string;
type QueryName = string;

export interface ApiContextValue {
  client: (queryName: `${Operation}.${Module}.${QueryName}`) => Client;
  sseClient: (queryName: `${Operation}.${Module}.${QueryName}`) => SSEClient;
}

export const ApiContext = React.createContext<ApiContextValue | null>(null);
